import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#202020"
        d="M21 20a1 1 0 01-1 1H4a1 1 0 01-1-1v-9.777a1 1 0 01.386-.79l8-6.222a1 1 0 011.228 0l8 6.222a1 1 0 01.386.79V20zm-2-1v-8.29l-7-5.443-7 5.444V19h14zM7 15h10v2H7v-2z"
      ></path>
    </svg>
  )
}

export default Icon
